export default {
  title: 'Dashboard',
  personalTitle: 'Personalize Dashboard',
  tab: 'DASHBOARD',
  btn: {
    my: 'My',
    all: 'All',
    jobs: 'Jobs',
    open: 'Open',
    applications: 'Applications',
    more: 'More',
    save: 'Save',
    cancel: 'Cancel',
    personalize: 'Personalize Dashboard',
    timeRange: {
      DAY_7: 'Last 7 days',
      DAY_30: 'Last 30 days',
      DAY_180: 'Last 180 days'
    }
  },
  message: {
    jobsInfo: {
      jobsOpen: 'Jobs Open',
      jobsScreening: 'Jobs Screening',
      interviewing: 'Interviewing',
      jobsHired: 'Jobs Hired / Onboarding',
      onHold: 'On-hold',
      addJobs: 'Add Jobs'
    },
    jobAgingList: {
      nameOne: '<20 days',
      nameTwo: '20-40 days',
      nameThree: '40-60 days',
      nameFour: '61+ days'
    },
    addJobs: 'Add Jobs',
    hasNoPermission: 'Oops! It seems you do not have the user permissions to perform this function. Please contact your administrator or your AJINGA customer success consultant for support. ',
    jobCountNoEnough: 'Oops! It seems you have reached the maximum number of open jobs your user permissions allow. Please contact your administrator or your AJINGA customer success consultant for support. ',
    addApplication: 'Add Application',
    interviewStatus: {
      finished: 'Rating Finished',
      scheduled: 'Scheduled',
      pending: 'Rating Pending',
      canceled: 'Canceled'
    },
    notification: {
      noMessage: 'Currently no system message'
    }
  },
  containerTitle: {
    jobs: 'Jobs',
    applications: 'Applications',
    interviews: 'Interviews',
    channels: 'Channels',
    talentPool: 'Talent Pool',
    jobAging: 'Job Aging',
    notification: 'New Alerts',
    application: {
      ALL: 'Total Applications',
      NEW: 'New Applications',
      UNREAD: 'Unread',
      SCREENING: 'Screening Applications',
      INTERVIEWING: 'Interviewing Applications',
      ONBOARDING: 'Onboarding Applications',
      LEADS: 'Leads'
    },
    interview: {
      interview: 'Interview',
      recruiter: 'Recruiter',
      managers: 'Hiring Manager(s)',
      status: 'Status'
    },
    recruiterKpi: 'Recruiter KPI Dashboard'
  },
  label: {
    channelName: {
      weChat: 'WeChat',
      referral: 'Referral',
      notPublic: 'Not Public'
    },
    showInMainView: 'Show In Main View',
    hideFromMainView: 'Hide From Main View',
    showInRightView: 'Show in right-side view',
    hideFromRightView: 'Hide from right-side view',
    interview: {
      candidateName: 'Candidate: ',
      interviewersName: 'Interviewers: '
    },
    selectCompany: 'Select Company',
    open: 'Open',
    all: 'All'
  }
}
